module.exports = __webpack_public_path__ + "static/10-UX-laws-you-need-to-know-a20949c621882abcc1b4c2fe303afc0c.png";